/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import NumberFormat from '../../util/NumberFormat'

export default function Money(props) {
  if (props.children === null) {
    return <span style={props.style || {}}>未入力</span>
  }

  const price = NumberFormat.commaSeparated(props.children) || 0

  return <span style={props.style || {}}>&yen;{price}</span>
}
